export function getResponseData(response: any) {
  return response?.data?.data ?? response?.data ?? [];
}
